import { MenuData } from '../layouts/types/menu-items-response';
import { AdminLinkActionType } from '../types';

export class MenuListItem {
  id: number;
  routerLink: string;
  prevRoute: string;
  currRoute: string;
  items?: MenuListItem[];
  actions: AdminLinkActionType[];
  icon?: string; // custom icon class
  sublinks: MenuData[];
  linkName: string;
  auditLink?: string;
  isDisplayInMenu: boolean;
  linkId?: number;
  childLinkIds?: number[];

  constructor(
    data: MenuData,
    prevRoute: string,
    sublinkMap: Map<string, number>,
    subLinkRoutes: string[],
  ) {
    this.linkName = data.linkName;
    this.isDisplayInMenu = data.isDisplayInMenu;
    this.actions = data?.actions ?? [];
    this.prevRoute = prevRoute;
    this.id = data.id;
    this.childLinkIds = data.childLinkIds;
    this.routerLink =
      this.prevRoute !== ''
        ? this.prevRoute +
          '/' +
          RouteConversion.convertNestedRoutes(data.linkName, data.sublinks)
        : RouteConversion.convertNestedRoutes(data.linkName, data.sublinks);
    this.currRoute =
      this.prevRoute + '/' + RouteConversion.convertToRoute(data.linkName);
    // If sublinks exists
    this.sublinks = data.sublinks ?? [];
    this.items = data.sublinks?.reduce((acc, subData) => {
      if (subData.isDisplayInMenu) {
        acc.push(
          new MenuListItem(
            subData,
            prevRoute + '/' + RouteConversion.convertToRoute(data.linkName),
            sublinkMap,
            subLinkRoutes,
          ),
        );
      }
      return acc;
    }, [] as MenuListItem[]);
    // Array for records of disabled breadcrumb labels
    if (!subLinkRoutes.includes(this.prevRoute.substring(1)))
      subLinkRoutes.push(this.prevRoute.substring(1));
    // Mapper for audit link id
    if (!data.sublinks || checkSubLinkValidity(data.sublinks))
      sublinkMap.set(this.routerLink, data.id);
  }
}

class RouteConversion {
  static convertNestedRoutes(linkName: string, sublinks?: MenuData[]): string {
    if (sublinks) {
      for (let i = 0; i < sublinks.length; i++) {
        if (sublinks[i].isDisplayInMenu) {
          return (
            this.convertToRoute(linkName) +
            '/' +
            this.convertNestedRoutes(sublinks[i].linkName, sublinks[i].sublinks)
          );
        }
      }
    }
    return this.convertToRoute(linkName);
  }

  static convertToRoute(linkName: string) {
    const converted = linkName
      .replaceAll(' ', '-')
      .replaceAll('/', '-')
      .toLocaleLowerCase();
    return converted.charAt(converted.length - 1) === '-'
      ? converted.slice(0, converted.length - 1)
      : converted;
  }
}

function checkSubLinkValidity(sublinkArr: MenuData[]) {
  for (let i = 0; i < sublinkArr.length; i++) {
    if (sublinkArr[i].isDisplayInMenu) return false;
  }
  return true;
}
